export const ATTRIBUTE_TYPES = {
  SELECT: 'SELECT',
  INTEGER: 'INTEGER',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  MULTISELECT: 'MULTISELECT',
  TEXT: 'TEXT',
  CHECKBOX: 'CHECKBOX',
  TIMESTAMP: 'TIMESTAMP',
  TIME: 'TIME',
  STRUCTURE: 'STRUCTURE',
} as const;

/**
 * Типы данных с выбором из справочника атрибута: значение — выбранный вариант или набор вариантов, одним значением.
 * Такой атрибут списком не бывает — набор вариантов уже задаёт сам тип
 */
export const SELECT_ATTRIBUTE_TYPES = [ATTRIBUTE_TYPES.SELECT, ATTRIBUTE_TYPES.MULTISELECT] as const;

/**
 * Тип атрибута (назначение)
 */
export const ATTRIBUTE_KINDS = {
  SYSTEM: 'SYSTEM',
  COMPUTED_TRANSCRIBATION: 'COMPUTED_TRANSCRIBATION',
  COMPUTED_RAW: 'COMPUTED_RAW',
  EXPERT_REPORT_RATING: 'EXPERT_REPORT_RATING',
  ANALYTICS: 'ANALYTICS',
} as const;

/** Код структуры, которой принадлежат корневые атрибуты: у атрибута вне структуры он стоит кодом родительской структуры */
export const ROOT_STRUCT_CODE = 'SIMPLE';

/**
 * Формат отображения значения атрибута
 * TIME — длительность («10:15» / «1:30:45»)
 * SECOND — число секунд (единица измерения выводится подписью рядом с названием атрибута)
 * PERCENT — процент («85.5%»)
 * Формат интервала, заданный числовому атрибуту, означает, что его значение — число секунд
 */
export const DISPLAY_FORMATS = {
  TIME: 'TIME',
  SECOND: 'SECOND',
  PERCENT: 'PERCENT',
} as const;

/**
 * Форматы, допустимые для каждого типа данных; отсутствующий здесь тип формат не принимает
 */
export const ALLOWED_DISPLAY_FORMATS = {
  [ATTRIBUTE_TYPES.TIME]: [DISPLAY_FORMATS.TIME, DISPLAY_FORMATS.SECOND],
  [ATTRIBUTE_TYPES.INTEGER]: [DISPLAY_FORMATS.TIME, DISPLAY_FORMATS.SECOND, DISPLAY_FORMATS.PERCENT],
  [ATTRIBUTE_TYPES.DECIMAL]: [DISPLAY_FORMATS.TIME, DISPLAY_FORMATS.SECOND, DISPLAY_FORMATS.PERCENT],
} as const;

/**
 * Типы атрибутов, у которых задаётся формат отображения
 */
export const DISPLAY_FORMAT_TYPES = [ATTRIBUTE_TYPES.INTEGER, ATTRIBUTE_TYPES.DECIMAL, ATTRIBUTE_TYPES.TIME] as const;

/**
 * Тип данных атрибута, у которого задаётся формат отображения
 */
export type DisplayFormatType = (typeof DISPLAY_FORMAT_TYPES)[number];
